import { createTailwindcss, type TailwindConfig } from '@mhsdesign/jit-browser-tailwindcss';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.main.config.mjs';

let config: TailwindConfig = resolveConfig(tailwindConfig);
config = {theme: config.theme};
config.important = '.cms-sections';
//config.prefix = 'cms-';

const tailwindCss = createTailwindcss({tailwindConfig: config});

export default async function tailwindCompiler(html: string) {
	return tailwindCss.generateStylesFromContent(`@tailwind utilities;`, [html]);
}
